    const target = document.querySelector('#storeifyapps-storelocator-shortcode');
    const delay = ms => new Promise(res => setTimeout(res, ms));

    const openFilters = async () => {
      //await delay(2000);
      document.getElementById('btn-filter').click();

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const product = urlParams.get('product')
      if(product == "Cookbook"){
        document.getElementById('storeifyapp_stores_tags_filter_72').click();
      }
      if(product=="RedGravy"){
        document.getElementById('storeifyapp_stores_tags_filter_0').click();
      }
    };

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if(mutation.target.id=='main-slider-storelocator'){
            observer.disconnect();
            openFilters();
        }

      });
    });

    const config = {
      childList: true,
        subtree: true,
    };

    observer.observe(target, config);